import { ItineraryStep } from "@contracts/itinerary";
import AddressHelper from "@helpers/AddressHelper";
import { CollabLocation } from "@contracts/collabLocations";

export interface AddressParts {
  city?: string;
  state?: string;
  country?: string;
}

/**
 * Pulls city/state/country out of a Google Place.
 * Note: Similar logic in PaidCreatorFields
 * NOTE! Logic duplicated in BackfillController.cs
 */
export function extractAddressParts(place: globalThis.google.maps.places.PlaceResult): AddressParts {
  const country = place.address_components?.find(c => c.types.includes("country"))?.short_name;
  const state = place.address_components?.find(c => c.types.includes("administrative_area_level_1"))?.short_name;
  let city = place.address_components?.find(c => c.types.includes("locality"))?.short_name;
  // If city is null fallback to AdminAreaL3 (typically a Township), then L2 (typically a county)
  if (!city) {
    city = place.address_components?.find(c => c.types.includes("administrative_area_level_3"))?.short_name;
  }
  if (!city) {
    city = place.address_components?.find(c => c.types.includes("administrative_area_level_2"))?.short_name;
  }
  return { city, state, country };
}

export default {
  clearPlaceFields(stop: ItineraryStep | CollabLocation) {
    stop.title = null;
    stop.externalId = null;
    stop.address = null;
    stop.website = null;
    stop.latitude = null;
    stop.longitude = null;
    stop.country = null;
    stop.state = null;
    stop.city = null;
  },

  setItineraryFieldsFromPlace(place: globalThis.google.maps.places.PlaceResult, stop: ItineraryStep | CollabLocation) {
    stop.title = place.name;
    stop.externalId = place.place_id;
    stop.address = AddressHelper.removeCountryAndZipCode(place.formatted_address);
    stop.website = place.website;

    if (place.geometry?.location) {
      stop.latitude = place.geometry.location.lat?.();
      stop.longitude = place.geometry.location.lng?.();
    }

    if (place.opening_hours?.weekday_text) {
      stop.openHours = place.opening_hours?.weekday_text;
    }

    // Set City, State, etc...
    const addressParts = extractAddressParts(place);
    stop.country = addressParts.country;
    stop.state = addressParts.state;
    stop.city = addressParts.city;
  },
};
